if (!customElements.get('mobile-sticky-buy')) {
  customElements.define(
    'mobile-sticky-buy',
    class MobileStickyBuy extends HTMLElement {
      constructor() {
        super();
        this.mobileMq = window.matchMedia('(max-width: 749px)');
        this.button = this.querySelector('.mobile-sticky-buy__button');
        this.buttonLabel = this.querySelector('.mobile-sticky-buy__button-label');
        this.originalLabel = this.buttonLabel ? this.buttonLabel.textContent : 'Add to cart';
        this.triggerVisible = true;
        this.drawerOpen = false;
      }

      connectedCallback() {
        if (!this.mobileMq.matches) return;

        const trigger = document.querySelector('.product__media-wrapper');
        if (!trigger) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.triggerVisible = entry.isIntersecting;
              this.updateVisibility();
            });
          },
          { rootMargin: '-25% 0px 0px 0px', threshold: 0 }
        );
        this.observer.observe(trigger);

        this.cartDrawer = document.querySelector('cart-drawer');
        if (this.cartDrawer) {
          this.drawerObserver = new MutationObserver(() => {
            this.drawerOpen = this.cartDrawer.classList.contains('active');
            this.updateVisibility();
          });
          this.drawerObserver.observe(this.cartDrawer, {
            attributes: true,
            attributeFilter: ['class'],
          });
          this.drawerOpen = this.cartDrawer.classList.contains('active');
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          this.cartUpdateUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
            if (data && data.source === 'product-form') this.showAddedState();
          });
        }

        this.mqHandler = (e) => {
          if (!e.matches) this.hide();
        };
        if (this.mobileMq.addEventListener) {
          this.mobileMq.addEventListener('change', this.mqHandler);
        } else {
          this.mobileMq.addListener(this.mqHandler);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.drawerObserver) this.drawerObserver.disconnect();
        if (this.cartUpdateUnsub) this.cartUpdateUnsub();
        if (this.addedTimer) clearTimeout(this.addedTimer);
        if (this.mqHandler) {
          if (this.mobileMq.removeEventListener) {
            this.mobileMq.removeEventListener('change', this.mqHandler);
          } else {
            this.mobileMq.removeListener(this.mqHandler);
          }
        }
      }

      updateVisibility() {
        if (!this.mobileMq.matches) return this.hide();
        if (this.drawerOpen) return this.hide();
        if (this.triggerVisible) return this.hide();
        this.show();
      }

      show() {
        if (this.classList.contains('is-visible')) return;
        this.classList.add('is-visible');
        document.body.classList.add('has-sticky-buy');
        const strip = document.querySelector('.mobile-sticky-buy__trust-strip');
        if (strip) {
          strip.hidden = false;
          document.body.classList.add('has-sticky-strip');
        }
      }

      hide() {
        if (!this.classList.contains('is-visible')) return;
        this.classList.remove('is-visible');
        document.body.classList.remove('has-sticky-buy');
        const strip = document.querySelector('.mobile-sticky-buy__trust-strip');
        if (strip) {
          strip.hidden = true;
          document.body.classList.remove('has-sticky-strip');
        }
      }

      showAddedState() {
        if (!this.buttonLabel) return;
        this.classList.add('is-added');
        this.buttonLabel.textContent = 'Added';
        clearTimeout(this.addedTimer);
        this.addedTimer = setTimeout(() => {
          this.buttonLabel.textContent = this.originalLabel;
          this.classList.remove('is-added');
        }, 1200);
      }
    }
  );
}
